/**
 * SharePoint team site URL helpers (ported from tools/codiii-site-connector).
 */

export function isPersonalOneDriveUrl(url) {
  if (!url) return false;
  const u = String(url).toLowerCase();
  return (
    u.includes('/personal/')
    || u.includes(':f:/g/personal/')
    || u.includes(':f:/r/personal/')
    || u.includes('-my.sharepoint.com')
  );
}

export function extractTeamSiteFromSharePointUrl(inputUrl) {
  const trimmed = String(inputUrl || '').trim();
  if (!trimmed) return null;
  if (isPersonalOneDriveUrl(trimmed)) return null;

  let uri;
  try {
    uri = new URL(trimmed);
  } catch {
    return null;
  }
  if (!['http:', 'https:'].includes(uri.protocol)) return null;
  if (!uri.hostname.toLowerCase().endsWith('.sharepoint.com')) return null;

  const hostBase = `${uri.protocol}//${uri.host}`;
  const decoded = decodeURIComponent(trimmed);

  const sitesPath = decoded.match(/https?:\/\/[^/\s]+\/sites\/([^/?#\s]+)/i);
  if (sitesPath) {
    return `${hostBase}/sites/${sitesPath[1]}`.replace(/\/$/, '');
  }

  const sharingTeam = trimmed.match(/https?:\/\/[^/]+\/:f:\/s\/([^/?#]+)/i);
  if (sharingTeam) {
    return `${hostBase}/sites/${sharingTeam[1]}`.replace(/\/$/, '');
  }

  const idMatch = trimmed.match(/[?&]id=([^&]+)/);
  if (idMatch) {
    const idPath = decodeURIComponent(idMatch[1]);
    const idSite = idPath.match(/\/sites\/([^/]+)/i);
    if (idSite) {
      return `${hostBase}/sites/${idSite[1]}`.replace(/\/$/, '');
    }
  }

  return null;
}

export function normalizeTeamSiteUrl(inputUrl) {
  const trimmed = String(inputUrl || '').trim();
  if (!trimmed) {
    throw new Error('Please paste a SharePoint link.');
  }
  if (isPersonalOneDriveUrl(trimmed)) {
    throw new Error(
      'This looks like personal OneDrive. This page is only for team SharePoint sites. '
      + 'Users sign in to CODiii with Microsoft for OneDrive.'
    );
  }
  const site = extractTeamSiteFromSharePointUrl(trimmed);
  if (site) {
    return site.replace(/\/$/, '');
  }
  throw new Error(
    'Could not find a team site in that link. Paste a site home URL, folder link, '
    + 'or sharing link from a SharePoint team site.'
  );
}
